import { useMemo } from 'react';
import { css } from '@emotion/react';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';

import NvPopover from 'shared/components/nv-popover';
import ParticipantDot from 'athena/components/participant-dot';
import ParticipantQuestionPill from './participant-question-pill';

type ParticipantsQuestionsPopoverProps = {
  menteeQuestion: string;
  mentorQuestion: string;
};

const ParticipantsQuestionsPopover = (props: ParticipantsQuestionsPopoverProps) => {
  const { menteeQuestion, mentorQuestion } = props;
  const participants = {
    [MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE]: menteeQuestion,
    [MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR]: mentorQuestion,
  };
  const popoverContent = useMemo(() => (
    <>
      {Object.entries(participants).map(([role, question], index) => (
        <ParticipantQuestionPill
          key={role}
          role={role as MentoringProgramRole}
          question={question}
          className={index === 0 ? 'mb-2' : ''}
        />
      ))}
    </>
  ), [menteeQuestion, mentorQuestion]);

  return (
    <NvPopover
      enabled
      showOnHover
      placement='top'
      content={popoverContent}
      overlayStyles={css`
        max-width: 350px;
      `}
    >
      <div className='d-flex flex-column mr-1'>
        <ParticipantDot
          role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE}
          className='mb-1'
        />
        <ParticipantDot
          role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR}
        />
      </div>
    </NvPopover>
  );
};

export default ParticipantsQuestionsPopover;
